import { useState } from 'react';
import ReactPlayer from 'react-player';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

import { Video } from 'src/models/Video';
import VideoThumbnail from 'src/components/atoms/video-thumbnail/VideoThumbnail';

interface VideoPlayerDialogProps {
  videoInfo: Video
  mediaContentClassName?: string
}

const VideoPlayerDialog: React.FC<VideoPlayerDialogProps> = ({ videoInfo, mediaContentClassName }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const closeButton = (
    <DialogTrigger action="close">
      <Button
        appearance="subtle"
        aria-label="close"
        icon={<Dismiss24Regular />}
        data-testid="close-video-player"
        onClick={handleClose}
      />
    </DialogTrigger>
  );

  return (
    <Dialog open={open}>
      <DialogTrigger disableButtonEnhancement>
        <VideoThumbnail videoInfo={videoInfo} onPlay={handleOpen} mediaContentClassName={mediaContentClassName} />
      </DialogTrigger>

      <DialogSurface>
        <DialogBody>
          <DialogTitle action={closeButton}></DialogTitle>

          <DialogContent data-testid="video-player-content">
            {/* TODO: Remove ReactPlayer and replace with SundaySky player */}
            <ReactPlayer url={videoInfo.mediaUrl} controls width="100%" height="auto" />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default VideoPlayerDialog;
